import { WorkOrderDetailsPage } from "@/views/WorkOrders/Details";

export const pages = {
  "work-orders.detail": WorkOrderDetailsPage,
};
